var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreentick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0039 38.5684C75.7148 37.8574 76.0703 36.9688 76.0703 35.9023C76.0703 34.7964 75.7148 33.888 75.0039 33.1771L69.6126 27.8451C68.8622 27.0946 67.9735 26.7194 66.9466 26.7194C65.9197 26.7194 65.031 27.0946 64.2806 27.8451L40.1087 51.9577L26.7194 38.5684C25.969 37.8179 25.0803 37.4427 24.0534 37.4427C23.0265 37.4427 22.1378 37.8179 21.3874 38.5684L15.9961 43.9004C15.2852 44.6113 14.9297 45.5197 14.9297 46.6257C14.9297 47.6921 15.2852 48.5807 15.9961 49.2917L37.4427 70.7383C38.1931 71.4887 39.0818 71.8639 40.1087 71.8639C41.1751 71.8639 42.0836 71.4887 42.834 70.7383L75.0039 38.5684ZM84.8978 22.6611C88.9659 29.6323 91 37.2452 91 45.5C91 53.7548 88.9659 61.3677 84.8978 68.3389C80.8296 75.31 75.31 80.8296 68.3389 84.8978C61.3677 88.9659 53.7548 91 45.5 91C37.2452 91 29.6323 88.9659 22.6611 84.8978C15.69 80.8296 10.1704 75.31 6.10221 68.3389C2.03407 61.3677 0 53.7548 0 45.5C0 37.2452 2.03407 29.6323 6.10221 22.6611C10.1704 15.69 15.69 10.1704 22.6611 6.10221C29.6323 2.03407 37.2452 0 45.5 0C53.7548 0 61.3677 2.03407 68.3389 6.10221C75.31 10.1704 80.8296 15.69 84.8978 22.6611Z",
    fill: "#66B954"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/greentick.9cd0f26240680de45732eb944e912e96.svg";
export { ForwardRef as ReactComponent };